module.exports = __webpack_public_path__ + "static/media/Image02.05170571.png";